import { render, staticRenderFns } from "./ChangeMastertableTeacherModal.vue?vue&type=template&id=0c1d9436"
import script from "./ChangeMastertableTeacherModal.vue?vue&type=script&lang=js"
export * from "./ChangeMastertableTeacherModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports